<script>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import Layout from "@/layouts/main-copy.vue";
import Footer from "@/components/footer";
import Scanning from '@/components/scanning.vue';
import InitialForm from '@/components/InitialForm.vue';
import Results from '@/components/Results.vue';
import Consigli from '@/components/Consigli.vue';

export default {
  name: 'Home',
  components: {
    Layout,
    Footer,
    InitialForm,
    Results,
    Consigli,
    Scanning,
  },
  setup() {
    const showInizioModal = ref(false);
    const showResultsModal = ref(false);
    const showScanning = ref(false);
    const showResults = ref(false);
    const breaches = ref([]);
    const noBreachesFound = ref(false);
    const email = ref('');
    const inizioModalShown = ref(false);
    const resultsModalShown = ref(false);

    const hideInizioModal = () => {
      showInizioModal.value = false;
    };

    const hideResultsModal = () => {
      showResultsModal.value = false;
    };

    const handleFormSubmission = ({ breaches: submittedBreaches, email: submittedEmail }) => {
      console.log('Form Submitted:');
      console.log('Breaches:', submittedBreaches);
      console.log('Email:', submittedEmail);

      showScanning.value = true;
      noBreachesFound.value = false;
      breaches.value = [];
      email.value = submittedEmail;

      setTimeout(() => {
        showScanning.value = false;
        showResults.value = true;
        breaches.value = submittedBreaches || [];
        noBreachesFound.value = breaches.value.length === 0;
        console.log('Breaches after timeout:', breaches.value);
        console.log('No Breaches Found:', noBreachesFound.value);
      }, 4000);
    };

    const reset = () => {
      breaches.value = [];
      noBreachesFound.value = false;
      showResults.value = false;

      inizioModalShown.value = false;
      resultsModalShown.value = false;
    };

    const handleMouseLeave = (e) => {
      if (!e.relatedTarget && !e.toElement) { // Ensures mouse actually left the window
        if (!showScanning.value) {
          if (!showResults.value && !inizioModalShown.value) {
            showInizioModal.value = true;
            inizioModalShown.value = true;
          } else if (showResults.value && !resultsModalShown.value) {
            showResultsModal.value = true;
            resultsModalShown.value = true;
          }
        }
      }
    };

    onMounted(() => {
      document.body.addEventListener('mouseleave', handleMouseLeave);
    });

    onBeforeUnmount(() => {
      document.body.removeEventListener('mouseleave', handleMouseLeave);
    });

    return {
      showInizioModal,
      hideInizioModal,
      showResultsModal,
      hideResultsModal,
      showScanning,
      showResults,
      breaches,
      noBreachesFound,
      handleFormSubmission,
      reset,
      email,
    };
  }
};
</script>

<template>
  <Layout>
    <b-modal v-model="showInizioModal" hide-footer modal-class="zoomIn" content-class="gradient-border-modal" centered size="lg">
      <div>
        <div class="fs-15 mx-4 mx-sm-5 mb-4">
          <h1>{{ $t('messaggio-di-test-inviato') }}</h1>
          <h3>SICURO DI NON VOLER ESEGUIRE IL TEST?..</h3>
          <p>
            Eseguendo il test scoprirai subito se la tua mail è stata coinvolta in furti di dati!<br>
            Questo ti permette di capire cosa è stato rubato e se devi modificare le tue password.<br>
            <b> --> Scopri i dati che un Hacker può usare contro di TE! &lt;-- </b>
          </p>
        </div>
      </div>
      <div class="text-center">
        <b-button class="custom-danger-button" @click="hideInizioModal">{{ $t('chiudi') }}</b-button>
      </div>
    </b-modal>

    <b-modal v-model="showResultsModal" hide-footer modal-class="zoomIn" content-class="gradient-border-modal" centered size="lg">
      <div>
        <div class="fs-15 mx-4 mx-sm-5 mb-4">
          <h1>{{ $t('messaggio-di-test-inviato') }}</h1>
          <h3>NON VUOI SCOPRIRE DI PIÙ?</h3>
          <p>
            Nella pagina successiva, scoprirai come ricevere una notifica in caso di violazione dei dati così da poter agire tempestivamente ed evitare il peggio!<br>
            <br>
            <b> PENSACI TU PRIMA CHE LO FACCIA UN HACKER! </b>
          </p>
        </div>
      </div>
      <div class="text-center">
        <b-button class="custom-danger-button" @click="hideResultsModal">{{ $t('eseguire-test') }}</b-button>
      </div>
    </b-modal>

    <div class="container-fluid">
      <div class="row">
        <div class="col-md-5"></div>
        <div class="col-md-7 d-flex align-items-center justify-content-center">
          <div
            :class="[
              showScanning 
                ? 'scanning-bg' 
                : breaches.length > 0 
                  ? 'result-red-bg' 
                  : 'default-bg'
            ]"
            style="padding: 20px; border-radius: 8px; box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); min-height: 100vh; width: 100%; display: flex; align-items: center; justify-content: center;"
          >
          <div v-if="showScanning" style="height: 100%; width: 100%; display: flex; align-items: center; justify-content: center;">
            <Scanning />
          </div>
          <div v-else>
            <InitialForm v-if="!showResults" @form-submitted="handleFormSubmission" />
            <div v-else>
              <Results :breaches="breaches" :noBreachesFound="noBreachesFound" @reset="reset" />
              <Consigli :violato="breaches.length > 0" :email="email" :landing="false" />
            </div>
          </div>
        </div>

        </div>
      </div>
    </div>
  </Layout>
  <Footer />
</template>

<style>
/* Define the custom property for the animation */
@property --bg-angle {
  inherits: false;
  initial-value: 0deg;
  syntax: "<angle>";
}

/* Keyframes for the spin animation */
@keyframes spin {
  to {
    --bg-angle: 360deg;
  }
}

/* Styling for the modal with gradient border and background */
.gradient-border-modal {
  position: relative;
  padding: 1rem;
  border-radius: 1rem;
  color: black !important; /* Force text color to black */
  text-align: center;
}

.gradient-border-modal::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: inherit;
  margin: -6px; /* This ensures the border is inside the modal */
  padding: 6px; /* Adjust the padding to ensure the gradient stays within the borders */
  background: conic-gradient(
    from var(--bg-angle),
    rgba(255, 0, 0, 0.6) 0%,
    rgba(255, 0, 0, 0.8) 2%,
    rgba(255, 0, 0, 1) 5%,
    rgba(255, 0, 0, 0.8) 8%,
    rgba(255, 0, 0, 0.6) 10%,
    rgb(240, 240, 245) 10%,
    rgb(240, 240, 245) 100%
  );
  animation: spin 2.5s infinite linear; /* Always running */
  z-index: -1;
  box-sizing: border-box; /* Ensures the pseudo-element respects the padding and border radius */
}

.gradient-border-modal * {
  color: black !important; /* Ensure all child elements have black text */
}

/* Custom button styles */
.custom-danger-button {
  background-color: red !important;
  color: white !important;
  border: none; /* Optionally remove the border */
  padding: 0.75rem 1.5rem; /* Increase padding for larger size */
  font-size: 1.125rem; /* Increase font size */
}

.custom-danger-button:hover {
  background-color: darkred !important; /* Darken the color on hover */
}

@keyframes alternate-bg {
  0% {
    background-color: rgba(255, 0, 0, 0.7); /* Rosso */
  }
  50% {
    background-color: rgba(0, 255, 0, 0.7); /* Verde */
  }
  100% {
    background-color: rgba(255, 0, 0, 0.7); /* Rosso */
  }
}

.default-bg {
  background-color: rgba(0, 50, 27, 0.7);
}

.scanning-bg {
  animation: alternate-bg 1.5s infinite; /* Applica l'animazione */
}

.result-red-bg {
  background-color: rgba(88, 0, 0, 0.7); /* Rosso */
}

</style>